import type { PropsWithChildren } from "react";
import type { BiCommonDataContextType } from "./BiCommonDataContext.ts";
import { BiCommonDataContext } from "./BiCommonDataContext.ts";

export const BiCommonDataContextProvider = ({ children, ...props }: PropsWithChildren<BiCommonDataContextType>) => (
  <BiCommonDataContext value={props}>{children}</BiCommonDataContext>
);
